import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'
import cx from 'classnames'

import acl from '../../../../../../../../services/acl'

import OwnershipEntity from './components/OwnershipEntity'
import OwnershipList from './components/OwnershipList'
import HistoryList from './components/HistoryList'

import hocConnect from './hocConnect'

import { TYPES } from './constants'

import './style.scss'

@acl
@hocConnect
export default class Ownership extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        hasRights: PropTypes.func,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        openDialog: PropTypes.func,
        openLinkagesById: PropTypes.func,
        renderBanner: PropTypes.func,
        toggledSections: PropTypes.object,
        toggleOwnershipSection: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            notIdentified: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            historyTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            holdingTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            owns: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            isOwned: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            noData: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            bannerLineText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            bannerButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    handleBannerClick = () => {
        const { openLinkagesById, hasRights, openDialog, mainId } = this.props
        if (hasRights('linkages')) {
            openLinkagesById(mainId)
        } else {
            openDialog('reportOwnershipConfirm')
        }
    }

    render() {
        const {
            module,
            block,
            customData,
            data,
            openDialog,
            mainId,
            toggledSections,
            toggleOwnershipSection,
            renderBanner,
            translates,
        } = this.props
        const { CHILDS, PARENTS } = TYPES

        return (
            <div className={'block-ownership'}>
                <div className={'linkages-banner'}>
                    <div className={'text-container'}>
                        <span>{translates.bannerLineText}</span>
                    </div>
                    <div className={'btn-container'}>
                        <button onClick={this.handleBannerClick} className={'dialog-button'}>
                            {translates.bannerButtonText}
                        </button>
                    </div>
                </div>
                <div
                    className={cx('ownership-wrap', 'root', {
                        'has-parents':
                            !_.isEmpty(_.get(data, 'parents', [])) || !_.isEmpty(_.get(data, 'parentsHistory', false)),
                    })}
                >
                    <div className={'main-parents-border'} />
                    <div className={'main-parents-content'}>
                        <div className={'parents-content-wrap'}>
                            {!_.isEmpty(_.get(data, 'parents', [])) && (
                                <OwnershipList
                                    module={module}
                                    block={block}
                                    customData={customData}
                                    renderBanner={renderBanner}
                                    parents={_.get(data, 'parents')}
                                    type={PARENTS}
                                    parentsPrimary
                                    openDialog={openDialog}
                                    mainId={mainId}
                                    translates={translates}
                                    toggledSections={toggledSections}
                                    identifier={`parent_section_${_.get(data, 'subject.id')}`}
                                    toggleOwnershipSection={toggleOwnershipSection}
                                />
                            )}
                            {_.get(data, 'parentsHistory', false) && (
                                <HistoryList
                                    module={module}
                                    block={block}
                                    customData={customData}
                                    history={_.get(data, 'parentsHistory')}
                                    identifier={'parents_section_history'}
                                    mainId={mainId}
                                    type={PARENTS}
                                    translates={translates}
                                    noParents={_.isEmpty(_.get(data, 'parents'))}
                                    collapsed={_.get(toggledSections, 'parents_section_history')}
                                    toggleOwnershipSection={toggleOwnershipSection}
                                />
                            )}
                        </div>
                        <OwnershipEntity
                            module={module}
                            block={block}
                            customData={customData}
                            subject={_.get(data, 'subject')}
                            relation={_.get(data, 'relation')}
                            primary
                            mainId={mainId}
                            noHistory={_.isEmpty(_.get(data, 'childrenHistory', []))}
                            hasParents={
                                !_.isEmpty(_.get(data, 'parents', [])) || !_.isEmpty(_.get(data, 'parentsHistory'))
                            }
                            identifier={`section_${_.get(data, 'subject.id')}`}
                            toggleOwnershipSection={toggleOwnershipSection}
                            toggledSections={toggledSections}
                            translates={translates}
                        />
                        {_.get(data, 'children', false) && (
                            <OwnershipList
                                module={module}
                                block={block}
                                customData={customData}
                                childs={_.get(data, 'children')}
                                renderBanner={renderBanner}
                                type={CHILDS}
                                openDialog={openDialog}
                                mainId={mainId}
                                noHistory={_.isEmpty(_.get(data, 'childrenHistory', []))}
                                toggledSections={toggledSections}
                                translates={translates}
                                identifier={`child_section_${_.get(data, 'subject.id')}`}
                                toggleOwnershipSection={toggleOwnershipSection}
                            />
                        )}
                        {_.get(data, 'childrenHistory', null) && (
                            <HistoryList
                                module={module}
                                block={block}
                                customData={customData}
                                history={_.get(data, 'childrenHistory')}
                                identifier={'child_section_history'}
                                mainId={mainId}
                                type={CHILDS}
                                translates={translates}
                                collapsed={_.get(toggledSections, 'child_section_history')}
                                toggleOwnershipSection={toggleOwnershipSection}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
